<app-common-template class="template-container" app-name="Plantillas Citación" controller-name="citationtemplate"
    edditable="false">
</app-common-template>